import { useEffect, useState } from "react";

// Interfaces
import { TInputData } from "@/Layouts/types/InputComponents/InputFormExtension";
import { IMatrixColumnProps } from "./interfaces";

// Layouts
import DoubleInput from "@/Layouts/components/InputComponents/DoubleInput";

// MUI
import { Stack } from "@mui/material";

export default function MatrixColumn(props: Readonly<IMatrixColumnProps>) {
	const {
		index = 0,
		item = null,
		errors = [],
		inputDefinitions = [],
		fromDisabled = false,
		toDisabled = false,
		readOnly = false,
		onActionUpdate = () => {},
		onChangeType = () => {},
	} = props;

	const [localInputs, setLocalInputs] = useState<TInputData[]>(inputDefinitions);

	useEffect(() => {
		setLocalInputs([...inputDefinitions]);

		return () => {
			setLocalInputs([]);
		};
	}, [inputDefinitions]);

	const firstInputDefinition = localInputs.map((input) => ({ ...input, dashed: fromDisabled }));
	const secondInputDefinition = localInputs.map((input) => ({ ...input, dashed: toDisabled }));

	return (
		<Stack>
			<DoubleInput
				firstInput={{
					data: [...firstInputDefinition],
					value: item?.from?.value ?? 0,
					defaultType: item?.from?.input ?? "Dollar",
					disabled: fromDisabled,
					error: Boolean(errors?.[index]?.from),
					readOnly: true,
					sx: { width: "95px" },
					onActionUpdate: (value) => {
						onActionUpdate?.(0, index, "column", "from", value);
					},
					onChangeType: (_, input) => {
						onChangeType?.(0, index, "column", "from", input);
					},
				}}
				secondInput={{
					readOnly,
					data: [...secondInputDefinition],
					value: item?.to?.value ?? Number.MAX_VALUE,
					defaultType: item?.to?.input ?? "Dollar",
					disabled: toDisabled,
					error: Boolean(errors?.[index]?.to),
					sx: { width: "95px" },
					onActionUpdate: (value) => {
						onActionUpdate?.(0, index, "column", "to", value);
					},
					onChangeType: (_, input) => {
						onChangeType?.(0, index, "column", "to", input);
					},
				}}
			/>
		</Stack>
	);
}
